export default "__VITE_ASSET__7f6578c9__"